import React from "react";
import { Link } from "react-router-dom";

const columns = (updateRole = false, returnUrl = null) => {
  let returnArray = [
    {
      text: "Name",
      dataField: "name",
    },
    {
      text: "Value",
      dataField: "value_display",
    },
  ];

  if (updateRole) {
    returnArray.push({
      text: "Edit",
      dataField: "edit",
      csvExport: false,
      formatter: (cell, row) => {
        const to = returnUrl
          ? `/global_settings/${row.id}/edit?returnUrl=${encodeURIComponent(returnUrl)}`
          : `/global_settings/${row.id}/edit`;
        return <Link to={to}>Edit</Link>;
      },
    });
  }

  return returnArray;
};

export default columns;
